function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.9797 23.5397V17.2933C24.9797 13.9467 23.1931 12.3893 20.8112 12.3893C18.8891 12.3893 18.0277 13.4469 17.5477 14.1888V12.6453H13.9264C13.9744 13.6677 13.9264 23.5397 13.9264 23.5397H17.5477V17.4555C17.5477 17.1307 17.5712 16.8053 17.6672 16.5728C17.9285 15.9221 18.5243 15.2485 19.5243 15.2485C20.8352 15.2485 21.3589 16.2475 21.3589 17.7115V23.5403H24.9797V23.5397ZM10.1115 11.1584C11.3739 11.1584 12.1605 10.3211 12.1605 9.2752C12.1371 8.20693 11.3739 7.3936 10.1355 7.3936C8.89707 7.3936 8.08693 8.2064 8.08693 9.2752C8.08693 10.3211 8.87307 11.1584 10.0885 11.1584H10.1115ZM16 32C7.16373 32 0 24.8363 0 16C0 7.1632 7.16373 0 16 0C24.8363 0 32 7.1632 32 16C32 24.8363 24.8363 32 16 32ZM11.9221 23.5397V12.6453H8.30133V23.5397H11.9221Z",
  fill: "#007AB9"
});

var SvgSourceLinkedin = function SvgSourceLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_linkedin.badf7757.svg";
export { ForwardRef as ReactComponent };